import { call, put, takeLatest } from "redux-saga/effects";
import { DetailStylingActions, GET_DETAIL_STYLING } from "@redux/reducer";
import {
  DetailStylingPayload,
  StylehintListUgcPayload,
  StylehintListUgcResponse,
  StylingDetailResponse,
  StylingDetailType
} from "@type/index";
import request from "@util/net/request";
import bffRequest from "@util/net/bff";
import axios, { AxiosResponse } from "axios";
import qs from "qs";
import { StylingStylehintDetailMapper } from "@util/net/queryParameters";

export function* getDetailStylingSaga(action: {
  payload: DetailStylingPayload;
}) {
  try {
    const payload: DetailStylingPayload = action.payload;
    yield put(DetailStylingActions.setDetailStylingErrorCode(""));
    yield put(DetailStylingActions.getDetailStylingLoading(true));
    const res: AxiosResponse<StylingDetailResponse> = yield call(
      bffRequest.get,
      "/styles/details",
      {
        params: {
          type: payload.type,
          styleId: payload.styleId,
          imageRatio: "3x4"
        }
      }
    );
    if (res.data.status === "ok") {
      if (res.data.result.styleImageUrl === "") {
        yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
      }
      // stylehint detail need to request bff and ugc proxy
      // becauseof bff response missing some keys, eg: storeId, box
      else if (payload.type === "sh") {
        try {
          const ugcRes: AxiosResponse<StylehintListUgcResponse> = yield call(
            request.get,
            "/contents/search",
            {
              params: {
                id_ugc_dist_content: [payload.styleId]
              },
              paramsSerializer: function (params: StylehintListUgcPayload) {
                return qs.stringify(params, { arrayFormat: "indices" });
              }
            }
          );
          if (ugcRes.data.content_list && ugcRes.data.content_list.length > 0) {
            const obj: StylingDetailType = StylingStylehintDetailMapper(
              ugcRes.data.content_list[0],
              res.data.result
            );
            yield put(DetailStylingActions.getDetailStylingSuccess(obj));
          } else {
            yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
          }
        } catch {
          yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
        }
      }
      // official detail need to request bff and ugc proxy
      // becauseof multi model position name should by language display, it comes from ugc
      else {
        yield put(
          DetailStylingActions.getDetailStylingSuccess(res.data.result)
        );
        // const { region, language } = store.getState().config;
        // const ugcRes: AxiosResponse<StylingOfficialDetailUgcResponse> =
        //   yield call(request.get, `/official/styles/${payload.styleId}`, {
        //     params: {
        //       "Content-Language": `${language}-${region.toUpperCase()}`
        //     },
        //     headers: {
        //       "Content-Language": `${language}-${region.toUpperCase()}`
        //     }
        //   });
        // if (res.data.status === "ok") {
        //   if (ugcRes.data.result.coordinate.length > 1) {
        //     const obj: StylingDetailType = StylingOfficialDetailMapper(
        //       ugcRes.data.result.coordinate,
        //       res.data.result
        //     );
        //     yield put(DetailStylingActions.getDetailStylingSuccess(obj));
        //   }
        //   yield put(DetailStylingActions.getDetailStylingSuccess(res.data.result));
        // } else if (
        //   res.data.status === "nok" &&
        //   res.data.error &&
        //   res.data.error.code === 404
        // ) {
        //   yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
        // } else {
        //   yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
        // }
      }
    } else if (
      res.data.status === "nok" &&
      res.data.error &&
      res.data.error.httpStatusCode === 404
    ) {
      yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
    } else {
      yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
    }
  } catch (error) {
    if (!axios.isCancel(error)) {
      const errorCode = JSON.parse(JSON.stringify(error)).status || null;
      if (errorCode && errorCode.toString() === "404") {
        yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
      } else {
        yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
      }
    }
  }
}

export function* watchLoadDetailStylingSaga() {
  yield takeLatest<any>(GET_DETAIL_STYLING, getDetailStylingSaga);
}
